<template>
  <TProse :responsive="responsive" :clear="clear">
    <MDC :value="text" />
  </TProse>
</template>

<script setup lang="ts">
export interface propsInterface {
  text: string
  responsive?: boolean
  clear?: boolean
}

withDefaults(defineProps<propsInterface>(), {
  responsive: false,
  clear: false,
})
</script>
